<template>
    <div class="container-pieChart_v">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/pie'



import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'pieChart_v',
  props: {  
    title:{
      type: String,
      default: ""
    }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
       title: {
              zlevel: 0,
              text: this.title,
              textStyle:{
                color:'#fff',
                fontSize:14
              },
              x: 'center',//文字位置
              y:'center'//文字位置
          },
        series: [
            {
            
                type: 'pie',
                radius: ['40%', '55%'],                
                labelLine:{  
                    normal:{  
                        
                          lineStyle: {
                            color: "#fff"  // 改变标示线的颜色
                          }
                    }
                },
                label: {
                    normal: {
                          textStyle: {
                          color: '#fff'  // 改变标示文字的颜色
                          }
                    }
                },
                data: [
                    {value: 45, name: '活跃会员',itemStyle:{color:'#4346D3'}},
                    {value: 25, name: '新会员',itemStyle:{color:'#8943D3'}},
                    {value: 5, name: '沉睡会员',itemStyle:{color:'#2D99FF'}},
                    {value: 20, name: '沉默会员',itemStyle:{color:'#6648FF'}},
                    {value: 5, name: '流失会员',itemStyle:{color:'#43D3C9'}}
                ]
            }
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-pieChart_v{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>